import type { ReactNode } from "react";

export enum UserRoleEnum {
  ADMIN = "Admin",
  SALES_MANAGER = "sales manager",
  PRODUCTION_TEAM_LEADER = "Production team leader",
  TECHNICIAN = "technician",
  SYSTEM_ADMINISTRATOR = "system administrator",
}

export enum UserDepartmentEnum {
  OFFICE_COMMERCIAL = "Office/Commercial",
  WELDING_PRODUCTION_FLOOR = "Welding/Production Floor",
  COLOR_DEPARTMENT = "Color department",
  INFORMATION_SYSTEM_MANAGEMENT = "Information system/management",
}

export enum UserStatusEnum {
  ACTIVE = "active",
  INACTIVE = "inactive",
  SUSPENDED = "suspended",
}

export enum ProfileSelectFieldEnum {
  CALENDAR_WEEK_START = "CALENDAR_WEEK_START",
  TIME_FORMAT = "TIME_FORMAT",
  DATE_FORMAT = "DATE_FORMAT",
}

export interface UserMeData {
  UserID: string;
  fullName: string;
  email: string;
  role: string;
  mobileNumber?: string | null;
  department?: string | null;
  status: string;
  profilePic?: string | null;
  createdAt: string;
  lastLogin?: string | null;
}

export interface UserMeApiResponse {
  statusCode: number;
  message: string;
  data: UserMeData;
}

export interface UpdateProfilePayload {
  fullName?: string;
  mobileNumber?: string;
  department?: UserDepartmentEnum;
  role?: UserRoleEnum;
  profilePic?: string;
}

export interface ProfileFieldProps {
  label: string;
  value: string;
  icon: ReactNode;
  type?: string;
  readOnly?: boolean;
  onChange?: (value: string) => void;
  onBlur?: () => void;
}

export interface ProfileSelectProps {
  label: string;
  value: string;
  options: { value: string; label: string }[];
}

export interface ProfileForm {
  fullName: string;
  mobileNumber: string;
}

export interface ProfileState {
  loading: boolean;
  updating: boolean;
  error: string | null;
  profile: UserMeData | null;
  form: ProfileForm;
}
